import { State } from 'modules/data';
import { mapBeneficiary } from 'modules/data/domain/schemas';
import { AsyncDataProvider } from 'modules/data-providers';
import { getRequest } from 'pages/requestForm/selectors/pageSelectors';
import { getRequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { FC, PropsWithChildren, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { api } from 'services/api';

import { getRuleTypeByEditMode } from '../../../../utils/helpers';
import { compareByCurrencyAndText, compareByTextLowerCase } from './BeneficiariesDataProvider.helpers';

interface BeneficiariesDataProvider extends PropsWithChildren {
    currencyCode: string;
}

const BeneficiariesDataProvider: FC<BeneficiariesDataProvider> = (props) => {
    const { currencyCode } = props;

    const request = useSelector(getRequest);
    const editMode = useSelector((state: State) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const onLoad = useCallback(
        async (filterText: string | null) => {
            const response = await api.airwallex.getBeneficiaries({
                requestId: request.id,
                companyId: request.companyId,
                query: filterText,
                startFrom: 0,
                rowNum: 116,
                ruleType,
            });

            const allBeneficiaries = response.items.map(mapBeneficiary);

            return [
                ...allBeneficiaries
                    .filter((beneficiary) => beneficiary.accountCurrency === currencyCode)
                    .sort(compareByTextLowerCase),
                ...allBeneficiaries
                    .filter((beneficiary) => beneficiary.accountCurrency !== currencyCode)
                    .sort(compareByCurrencyAndText),
            ];
        },
        [request.id, request.companyId, currencyCode, ruleType]
    );

    return (
        <AsyncDataProvider
            cacheStorageId={`requestOptions.beneficiaries.${request.companyId}.${currencyCode}.${editMode}`}
            pageSize={100}
            onLoad={onLoad}
        >
            {props.children}
        </AsyncDataProvider>
    );
};

export default BeneficiariesDataProvider;
